$(function () {
  $('.burger_btn').on('click', function () {
    $('.burger_btn').toggleClass('close');
    $('.header_menu').fadeToggle(500);
  });
});

//inview
//home
$(function () {
  $('.usevoice_list_item01').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('.usevoice_list_item01 .img_area').addClass('fade_up');
        $('.usevoice_list_item01 .img_area').removeClass('standby');
      }
      var ani_2 = function () {
        $('.usevoice_list_item01 .txt_area').addClass('fade_up');
        $('.usevoice_list_item01 .txt_area').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
        setTimeout(ani_2, 300);
      });
    }
  });
});
$(function () {
  $('.usevoice_list_item02').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('.usevoice_list_item02 .img_area').addClass('fade_up');
        $('.usevoice_list_item02 .img_area').removeClass('standby');
      }
      var ani_2 = function () {
        $('.usevoice_list_item02 .txt_area').addClass('fade_up');
        $('.usevoice_list_item02 .txt_area').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 100);
        setTimeout(ani_2, 300);
      });
    }
  });
});
$(function () {
  $('.pagelink').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('.pagelink_list').addClass('fade_up');
        $('.pagelink_list').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
      });
    }
  });
});

//contact
$(function () {
  $('#contactpage').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('#contactpage .h2_b').addClass('fade_up');
        $('#contactpage .h2_b').removeClass('standby');
      }
      var ani_2 = function () {
        $('#contactpage .txt').addClass('fade_up');
        $('#contactpage .txt').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
        setTimeout(ani_2, 300);
      });
    }
  });
});

//blog
$(function () {
  $('#blogpage').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('#blogpage .h2_b').addClass('fade_up');
        $('#blogpage .h2_b').removeClass('standby');
      }
      var ani_2 = function () {
        $('#blogpage .txt').addClass('fade_up');
        $('#blogpage .txt').removeClass('standby');
      }
      var ani_3 = function () {
        $('#blogpage .blog_list').addClass('fade_up');
        $('#blogpage .blog_list').removeClass('standby');
      }
      var ani_4 = function () {
        $('#blogpage .pagination').addClass('fade_up');
        $('#blogpage .pagination').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
        setTimeout(ani_2, 300);
        setTimeout(ani_3, 600);
        setTimeout(ani_4, 600);
      });
    }
  });
});
$(function () {
  $('#articlepage').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('#articlepage .h2_b').addClass('fade_up');
        $('#articlepage .h2_b').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
      });
    }
  });
});

//product
$(function () {
  $('#collectionpage').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('#collectionpage .h2_b').addClass('fade_up');
        $('#collectionpage .h2_b').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
      });
    }
  });
});

//about
$(function () {
  $('.about_theme_head').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('.about_theme_head').addClass('fade_up');
        $('.about_theme_head').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
      });
    }
  });
});
$(function () {
  $('.about_theme_body').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('.about_theme_body .float-l').addClass('fade_up');
        $('.about_theme_body .float-l').removeClass('standby');
      }
      var ani_2 = function () {
        $('.about_theme_body .img1').addClass('fade_up');
        $('.about_theme_body .img1').removeClass('standby');
      }
      var ani_3 = function () {
        $('.about_theme_body .about_theme_flex').addClass('fade_up');
        $('.about_theme_body .about_theme_flex').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
        setTimeout(ani_2, 0);
        setTimeout(ani_3, 300);
      });
    }
  });
});
$(function () {
  $('.about_main').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('.about_main .h2_b').addClass('fade_up');
        $('.about_main .h2_b').removeClass('standby');
      }
      var ani_2 = function () {
        $('.about_main .desc').addClass('fade_up');
        $('.about_main .desc').removeClass('standby');
      }
      var ani_3 = function () {
        $('.about_main .about_main_contents').addClass('fade_up');
        $('.about_main .about_main_contents').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
        setTimeout(ani_2, 300);
        setTimeout(ani_3, 600);
      });
    }
  });
});
$(function () {
  $('.about_features').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('.about_features .h2_b').addClass('fade_up');
        $('.about_features .h2_b').removeClass('standby');
      }
      var ani_2 = function () {
        $('.about_features .desc').addClass('fade_up');
        $('.about_features .desc').removeClass('standby');
      }
      var ani_3 = function () {
        $('.about_features .about_features_flex-01').addClass('fade_up');
        $('.about_features .about_features_flex-01').removeClass('standby');
      }
      var ani_4 = function () {
        $('.about_features .about_features_flex-02').addClass('fade_up');
        $('.about_features .about_features_flex-02').removeClass('standby');
      }
      var ani_5 = function () {
        $('.about_features .about_features_flex-03').addClass('fade_up');
        $('.about_features .about_features_flex-03').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
        setTimeout(ani_2, 300);
        setTimeout(ani_3, 600);
        setTimeout(ani_4, 900);
        setTimeout(ani_5, 1200);
      });
    }
  });
});
$(function () {
  $('.about_merit').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('.about_merit h2.h2_b').addClass('fade_up');
        $('.about_merit h2.h2_b').removeClass('standby');
      }
      var ani_2 = function () {
        $('.about_merit .about_merit_content_item-01').addClass('fade_up');
        $('.about_merit .about_merit_content_item-01').removeClass('standby');
      }
      var ani_3 = function () {
        $('.about_merit .about_merit_content_item-02').addClass('fade_up');
        $('.about_merit .about_merit_content_item-02').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
        setTimeout(ani_2, 300);
        setTimeout(ani_3, 600);
      });
    }
  });
});

//education
$(function () {
  $('.education_sall').on('inview', function (event, isInView) {
    if (isInView) {
      var ani_1 = function () {
        $('.education_sall').addClass('fade_up');
        $('.education_sall').removeClass('standby');
      }
      $(function () {
        setTimeout(ani_1, 0);
      });
    }
  });
});

//accordion(about)
$(function () {
  $('.about_main_item_01').on('click', function () {
    $('.about_main_item_01').toggleClass('open');
    $('.item_inner-01').fadeToggle(500);
    $('.about_main_item_02').removeClass('open');
    $('.about_main_item_03').removeClass('open');
    $('.item_inner-02').css('display','none');
    $('.item_inner-03').css('display','none');
  });
  $('.item_inner-01 .close').on('click', function () {
    $('.about_main_item_01').toggleClass('open');
    $('.item_inner-01').fadeToggle(500);
  });
});
$(function () {
  $('.about_main_item_02').on('click', function () {
    $('.about_main_item_02').toggleClass('open');
    $('.item_inner-02').fadeToggle(500);
    $('.about_main_item_01').removeClass('open');
    $('.about_main_item_03').removeClass('open');
    $('.item_inner-01').css('display','none');
    $('.item_inner-03').css('display','none');
  });
  $('.item_inner-02 .close').on('click', function () {
    $('.about_main_item_02').toggleClass('open');
    $('.item_inner-02').fadeToggle(500);
  });
});
$(function () {
  $('.about_main_item_03').on('click', function () {
    $('.about_main_item_03').toggleClass('open');
    $('.item_inner-03').fadeToggle(500);
    $('.about_main_item_01').removeClass('open');
    $('.about_main_item_02').removeClass('open');
    $('.item_inner-01').css('display','none');
    $('.item_inner-02').css('display','none');
  });
  $('.item_inner-03 .close').on('click', function () {
    $('.about_main_item_03').toggleClass('open');
    $('.item_inner-03').fadeToggle(500);
  });
});
//accordion(education)
$(function(){
  $(".read_contents dt").on("click", function() {
    $(this).next().slideToggle();
    $(this).toggleClass('open');
  });
});

// Sub Title
$(window).scroll(function () {
  $('.sub-title span').each(function(){
    var position = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > position - windowHeight){
      $(this).addClass('scroll-in');
    }
  });
});
$(window).scroll(function () {
  $('.sub-title img').each(function(){
    var position = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > position - windowHeight){
      $(this).addClass('scroll-in');
    }
  });
});